import apiFetch from "@wordpress/api-fetch";
import {getRoute} from "@wc-stripe/blocks-utils";

export const doShippingUpdate = (data) => {
    return apiFetch({
        method: 'POST',
        url: getRoute('cart/shipping'),
        data: data
    })
}